import { fabric } from 'fabric';
import Vec2 from 'vec2';

import {
  BATWING_ANGLE,
  CANVAS_OBJECT_TYPE_PREFIX,
  EDGE_STROKE_WIDTH,
} from '~/core/constants';
import { CornerInfo, DrawingEdge, DrawingShape } from '~/core/models';
import theme from '~/theme/theme';

const {
  drawingTool: { secondaryBorderColor },
} = theme.light;

export const addRoundedCornerRadiusArc = (
  shape: DrawingShape,
  edge: DrawingEdge,
  endPt: CornerInfo
) => {
  // add a rounded corner radius arc if appropriate
  const angleOffset = endPt.angle > 0 ? 0 : 90; // not needed for exterior radii
  const angleOffset2 = endPt.angle === BATWING_ANGLE ? 45 : 0;
  const fillColor = endPt.angle > 0 ? '' : '#fff'; // not needed for exterior radii

  // build the actual corner radius arc and add it to the canvas. Reuses edge.id
  const circle = new fabric.Circle({
    name: `${CANVAS_OBJECT_TYPE_PREFIX.CORNER_RADIUS_ARC}_${edge.id}`,
    radius: endPt.size,
    left: (endPt.radiusCenterPoint as Vec2).x,
    top: (endPt.radiusCenterPoint as Vec2).y,
    originX: 'center',
    originY: 'center',
    angle: endPt.orientationAngle,
    startAngle: 0 - angleOffset + angleOffset2,
    endAngle:
      endPt.angle % 90 ? 45 - angleOffset + angleOffset2 : 90 - angleOffset,
    stroke: secondaryBorderColor,
    strokeWidth: EDGE_STROKE_WIDTH,
    fill: fillColor,
    selectable: false,
  });

  shape.fabricGroup.addWithUpdate(circle);
};
